import { render, staticRenderFns } from "./MyNominees.vue?vue&type=template&id=09f6f800"
import script from "./MyNominees.vue?vue&type=script&lang=js"
export * from "./MyNominees.vue?vue&type=script&lang=js"
import style0 from "./MyNominees.vue?vue&type=style&index=0&id=09f6f800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports